require('normalize.css/normalize.css');
require('./styles/index.scss');

import Mouse from "./utils/mouse"
import Easing from "./utils/easing"
import SimpleNoise1D from "./utils/noise"

const canvas = document.querySelector('.main-canvas')
canvas.width = window.innerWidth * window.devicePixelRatio
canvas.height = window.innerHeight * window.devicePixelRatio
const ctx = canvas.getContext("2d")
const img = document.querySelector('img')

let mouseX
let mouseY

const colors = {
    0: ['#f4f1de', '#e07a5f', '#3d405b', '#81b29a', '#f2cc8f'],
    1: ['#335c67', '#fff3b0', '#e09f3e', '#9e2a2b', '#540b0e'],
    2: ['#006d77', '#83c5be', '#edf6f9', '#ffddd2', '#e29578'],
    3: ['#3d5a80', '#98c1d9', '#e0fbfc', '#ee6c4d', '#293241'],
    4: ['#22223b', '#4a4e69', '#9a8c98', '#c9ada7', '#f2e9e4'],
    5: ['#ff9f1c', '#ffbf69', '#ffffff', '#cbf3f0', '#e29578'],
    6: ['#2b2d42', '#8d99ae', '#edf2f4', '#ef233c', '#d90429'],
    7: ['#001524', '#15616d', '#ffecd1', '#ff7d00', '#78290f'],
    8: ['#d9d9d9', '#353535', '#3c6e71', '#ffffff', '#284b63'],
    9: ['#001427', '#708d81', '#f4d58d', '#bf0603', '#8d0801'],
    10: ['#1f2041', '#4b3f72', '#ffc857', '#119da4', '#19647e'],
    11: ['#f4d8cd', '#3a2e39', '#1e555c', '#edb183', '#f15152']
}

const getRand = max => {
    return Math.floor(Math.random() * max)
};

const getRandRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

class Point {

    constructor(x, y, size=50, color) {
        this.x = x
        this.y = y
        this.color = color
        this.size = size
        this.targetX
        this.speed = Math.floor(Math.random() * (100 - 10 + 1) + 10)
    }

    draw() {
        ctx.save()
        ctx.translate(this.x, this.y)
        ctx.beginPath()
        ctx.fillStyle = this.color
        ctx.arc(0, 0, this.size, 0, Math.PI * 2, true)
        ctx.fill()
        ctx.closePath()
        ctx.restore()
    }
}

let points = []

let time = 0

let palette

const update = () => {

    if(palette === undefined) {
        palette = colors[getRand(12)]
    }

    requestAnimationFrame(update)

    ctx.beginPath()
    ctx.fillStyle = palette[0]
    ctx.rect(0, 0, canvas.width, canvas.height)
    ctx.fill()
    ctx.closePath()

    ctx.save()

    ctx.restore()

    let MAX = 150

    if(points.length<MAX) {
        for(let i=0; i<=MAX; i++) {
            points.push(new Point(getRand(canvas.width) + (Math.cos(i) * 350), -100, 50, palette[getRandRange(1, 4)]))
        }
    }

    let i = 0
    points.forEach(point => {
        point.x < canvas.width ? point.x += 1 * point.speed / 3 : point.x = 0
        point.y < canvas.height ? point.y += 1 * point.speed / 3 : point.y = 0
        point.draw()
        i++
    })

    time++

}

requestAnimationFrame(update)
